interface ErrorDisplayProps {
  message: string;
  className?: string;
}

export default function ErrorDisplay({
  message,
  className = "p-4 text-center text-red-700 bg-red-100 rounded-lg whitespace-pre-wrap",
}: ErrorDisplayProps) {
  return <div className={className}>{message}</div>;
}
